import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=b0275330&scoped=true&"
import script from "./Common.vue?vue&type=script&lang=js&"
export * from "./Common.vue?vue&type=script&lang=js&"
import style0 from "./Common.vue?vue&type=style&index=0&id=b0275330&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0275330",
  null
  
)

export default component.exports